import config from "./config.json"

const {
    basepath: { production, development },
} = config;

const FETCHING = "FETCHING";
const NOT_FETCHING = "NOT FETCHING";
const FETCHED = "FETCHED";

const routerBasepath = process.env.isProd ? production : development;

export { FETCHING, NOT_FETCHING, FETCHED, routerBasepath };
